export default "__VITE_ASSET__c65fd12c__"